import { View } from "react-native";
import React from "react";
import { useAccount } from "hooks/useAccount";
import { useFetchTenantConfigurationQuery } from "queries/configuration.queries";
import WhiteText from "components/WhiteText";
import { formatCurrency } from "utils/appUtils";

const AccountCredits = () => {
  const { account } = useAccount();
  const accountCredits = account?.balances
    .filter((balance) => balance.code === "AP_SUBSCRIBER")
    .reduce((acc, balance) => acc + Number(balance.balance), 0);

  if (!accountCredits) return null;

  return (
    <View className="mb-2">
      <WhiteText>Account Credit:</WhiteText>
      <WhiteText style={{ fontSize: 36, fontWeight: "700" }}>
        {formatCurrency(accountCredits, {
          priceType: "CURRENCY",
        })}
      </WhiteText>
    </View>
  );
};

export default AccountCredits;
